<template lang="pug">
  #change-plan
    template(v-if="loading === true")
      loading(:height="200")
    template(v-else)
      #tmp-container.mt-3
        app-messages(:errorMessages="error_msg_list.top")
        template(v-if="available_plan_change === true")
          p.mb-0 ※「プラン変更」ボタンが表示されているプランへ変更される場合は、「プラン変更」ボタンを押し、必要事項をご記入の上、お申し込みください。
          p ※「申請書」ボタンが表示されているプランへ変更される場合は、「申請書」ボタンを押し、ダウンロードされた申請書に必要事項をご記入の上、[aporder@desknets.com]までメールにてご送信ください。
        template(v-else)
          p ※プランの変更をされる場合は、申請書をダウンロードしていただき、必要事項をご記入の上、[aporder@desknets.com]までメールにてご送信ください。
        b-card-group(deck)
          b-card(v-for="key in Object.keys(plans)", :key="plans[key].title", :header="plans[key].title" class="text-center card font-weight-bold" footer-tag="footer")
            b-card-text
              small 1ユーザー
              h5.font-weight-bold ￥{{plans[key].price.toLocaleString()}} / 月

              small ご利用いただけるサービス
              .mb-2
              div.mb-3.mr-3(v-if="plans[key].services.includes('neo')")
                img.logo_desknets(src="@/assets/images/logo_desknetsneo_clear_background.png")
              div.mb-3.mr-3(v-if="plans[key].services.includes('appsuite')")
                img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
              div.mb-3.mr-3(v-if="plans[key].services.includes('chatluck')")
                img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
            template#footer
              .height-service-1(v-if="plans[key].services.length === 1")
              .height-service-2(v-if="plans[key].services.length === 2")
              template(v-if="plans[key].buttons === 'apply'")
                b-button.float-center.mt-3(pill, variant="outline-primary", @click="applyPlan(plans[key].plan)")
                  .float-left.search_message.mr-1.font-weight-bold 申し込む
                  b-icon.float-right.next-icon(icon="arrow-right-circle")
              template(v-if="plans[key].buttons === 'download'")
                b-button.float-center.mt-3(pill, variant="outline-primary", @click="downloadFile(application_doc.path, application_doc.name)")
                  .float-left.search_message.mr-1.font-weight-bold 申請書
                  b-icon.float-right.next-icon(icon="arrow-down-circle")
              template(v-if="plans[key].buttons.includes('change')")
                b-button.float-center.my-3(pill, variant='outline-primary', @click="changePlan(plans[key].plan, true)")
                  .float-left.search_message.mr-1.font-weight-bold プラン変更
                  b-icon.float-right.next-icon(icon='arrow-right-circle')
              template(v-if="plans[key].buttons === 'contract'")
                h5.font-weight-bold.pt-4 ご契約中
              template(v-if="plans[key].buttons === 'processed'")
                h5.font-weight-bold.pt-4 申請中
              .mb-3
      //- プラン変更申し込みフォーム
      b-card#change-plan-anchor(v-if="plan_change_data.show_change_plan === true")
        b-container
          h4.font-weight-bold.mt-3.mb-3 プラン変更申し込み
          p.ml-5.text-danger ※オプションの変更お申し込みはプラン変更のお申し込みの後、別途お申し込みください
          b-row.plan-bg.pt-3
            b-col(cols='1')
            b-col(cols='4')
              h4.for-weight-bold.text-center 現在のプラン
              .mb-1(v-for="(plan_name, i) in plan_change_data.before_plan", :key="i")
                b-card(v-if="plan_name === 'appsuite'", header="AppSuite", class='text-center font-weight-bold')
                  b-card-text
                    small ご利用いただけるサービス
                    .mb-2
                    div.mb-3.mr-3
                      img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                    small ご契約中のユーザー数
                    h5.font-weight-bold {{ plan_change_data.user_list[plan_name] }}ユーザー
                b-card(v-else, :header="getPlanInfo(plan_name).title", class='text-center font-weight-bold')
                  b-card-text
                    small ご利用いただけるサービス
                    .mb-2
                    div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('neo')")
                      img.logo_desknets(src='@/assets/images/logo_desknetsneo_clear_background.png')
                    div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('appsuite')")
                      img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                    div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('chatluck')")
                      img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                    small ご契約中のユーザー数
                    h5.font-weight-bold {{ plan_change_data.user_list[plan_name] }}ユーザー
            b-col(cols='2', class='d-flex align-items-center justify-content-center')
              b-icon(icon="arrow-right" variant="secondary" font-scale="4")
            b-col(cols='4')
              h4.for-weight-bold.text-center 変更後のプラン
              b-card.mb-1(:header="after_plan_info.title", class='text-center font-weight-bold')
                b-card-text
                  small ご利用いただけるサービス
                  .mb-2
                  div.mb-3.mr-3(v-if="after_plan_info.services.includes('neo')")
                    img.logo_desknets(src='@/assets/images/logo_desknetsneo_clear_background.png')
                  div.mb-3.mr-3(v-if="after_plan_info.services.includes('appsuite')")
                    img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                  div.mb-3.mr-3(v-if="after_plan_info.services.includes('chatluck')")
                    img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                  small 変更後のユーザー数
                  h5.font-weight-bold {{ plan_change_data.plan_user }}ユーザー
              b-card.mb-1(v-if="no_change_to_appsuite", header="AppSuite", class='text-center font-weight-bold')
                b-card-text
                  small ご利用いただけるサービス
                  .mb-2
                  div.mb-3.mr-3
                    img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                  small 変更後のユーザー数
                  h5.font-weight-bold {{ contract_appsuite_user }}ユーザー
              b-card.mb-1(v-if="no_change_to_chatluck", :header="plans.chatluck.title", class='text-center font-weight-bold')
                b-card-text
                  small ご利用いただけるサービス
                  .mb-2
                  div.mb-3.mr-3
                    img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                  small 変更後のユーザー数
                  h5.font-weight-bold {{ contract_chat_user }}ユーザー
            b-col(cols='1')
          //- ユーザー数入力
          #changed_user
          b-row.plan-bg.pt-3
            b-col
              b-form-group.align-content(
                  label-cols='4',
                  label-align='right',
                  label-size='sm',
                  label="変更後のユーザー数",
                  :label-class="required_label_class",
                )
                  .form-inline
                    b-form-input.input-size.mb-2(size='sm', v-model="plan_change_data.plan_user", :state="error_msg_list.changed_user.length === 0 ? null : false")
                    b-form-text.ml-1.mb-2 ユーザー
                  div
                    b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.changed_user", :key="i") {{ error_msg }}
                  b-form-text
                    p ※最低契約ユーザー数は5ユーザーです。
                    p ※ご契約単位は1ユーザー単位です。
          //- desknet's NEO ドメイン名
          template(v-if="show_neo_domain !== ''")
            #neo_domain
            //- ドメインを入力
            template(v-if="show_neo_domain === 'input'")
              b-row.neo-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label="desknet's NEO ご希望サブドメイン名",
                    :label-class="required_label_class"
                  )
                    .form-inline
                      b-form-input.input-size.mb-2(size='sm', v-model="plan_change_data.neo_sub_domain", @change="domainCheck('0')", :state="error_msg_list.neo_domain.length === 0 ? null : false")
                      b-form-text.ml-1.mb-2 .dn-cloud.com
                    div
                      b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.neo_domain", :key="i") {{ error_msg }}
                    b-form-text
                      p ※お客さまを識別するアクセスURLの一部になります。
                      p ※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。
              #migration
              //- 試使用からの移行
              b-row.neo-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label='無料お試し版からのデータ移行',
                    :label-class="elective_label_class"
                  )
                    b-form-checkbox(v-model="plan_change_data.migration", :state="error_msg_list.migration.length === 0 ? null : false") 希望する
                    p.ml-3.font-weight-bold.text-danger ※移行作業中は試使用環境が停止します。
                    b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.migration", :key="i") {{ error_msg }}
              #migration_url
              b-row.neo-bg.pt-3(v-if="plan_change_data.migration === true")
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label='試使用環境URL',
                    :label-class="required_label_class"
                  )
                    .form-inline
                      b-form-input.textarea-size.mb-2(size='sm', v-model="plan_change_data.migration_url", placeholder='https://dn06110.dncloudtrial.com/cgi-bin/123456/dneo/dneo.cgi', :state="error_msg_list.migration_url.length === 0 ? null : false")
                    b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.migration_url", :key="i") {{ error_msg }}
            //- 契約しているドメインを表示
            template(v-else)
              b-row.neo-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label="ご契約中のdesknet's NEO サブドメイン名",
                  )
                    .form-inline
                      b-form-text.display-font-size {{ display_neo_domain }}
          //- ChatLuck ドメイン名
          template(v-if="show_chat_domain !== ''")
            #chat_domain
            //- ドメインを入力
            template(v-if="show_chat_domain === 'input'")
              b-row.chat-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label='ChatLuck ご希望サブドメイン名',
                    :label-class="required_label_class"
                  )
                    .form-inline
                      b-form-input.input-size.mb-2(size='sm', v-model="plan_change_data.chat_sub_domain", @change="domainCheck('1')", :state="error_msg_list.chat_domain.length === 0 ? null : false")
                      b-form-text.ml-1.mb-2 .chatluck.net
                    div
                      b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.chat_domain", :key="i") {{ error_msg }}
                    b-form-text
                      p ※お客さまを識別するアクセスURLの一部になります。
                      p ※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。
              #chat_migration
              //- 試使用からの移行
              b-row.chat-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label='無料お試し版からのデータ移行',
                    :label-class="elective_label_class"
                  )
                    b-form-checkbox(v-model="plan_change_data.chat_migration", :state="error_msg_list.chat_migration.length === 0 ? null : false") 希望する
                    p.ml-3.font-weight-bold.text-danger ※移行作業中は試使用環境が停止します。
                    b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.chat_migration", :key="i") {{ error_msg }}
              #chat_migration_url
              b-row.chat-bg.pt-3(v-if="plan_change_data.chat_migration === true")
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label='試使用環境URL',
                    :label-class="required_label_class"
                  )
                    .form-inline
                      b-form-input.textarea-size.mb-2(size='sm', v-model="plan_change_data.chat_migration_url", placeholder='https://trial-v0r3.chatluck.net/cgi-bin/123456/chatlk/chat.cgi', :state="error_msg_list.chat_migration_url.length === 0 ? null : false")
                    b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.chat_migration_url", :key="i") {{ error_msg }}
            //- 契約しているドメインを表示
            template(v-else)
              b-row.chat-bg.pt-3
                b-col
                  b-form-group.align-content(
                    label-cols='4',
                    label-align='right',
                    label-size='sm',
                    label="ご契約中のChatLuck サブドメイン名",
                  )
                    .form-inline
                      b-form-text.display-font-size {{ display_chat_domain }}
          b-row.other-bg.pt-3
            b-col(v-if="plan_change_data.migration === true || plan_change_data.chat_migration === true")
              #migration_datetime
              b-form-group.align-content(
                label-cols='4',
                label-align='right',
                label-size='sm',
                label='無料お試し版からのデータ移行作業日時',
                :label-class="required_label_class"
              )
                .form-inline
                  b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                  select-datetime(v-model="migration_datetime", @done="setDateTime")
                b-form-text.mb-2.datetime-text {{ showMigrationTime }}
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg, i) of error_msg_list.migration_datetime", :key="i") {{ error_msg }}
            b-col(v-else)
              #opening_date
              b-form-group.align-content(
                label-cols='4',
                label-align='right',
                label-size='sm',
                label='変更希望日',
                :label-class="required_label_class"
              )
                b-form-datepicker.input-size.mb-2(
                  size='sm',
                  v-model="plan_change_data.preferred_date",
                  :min="preferred_date_min",
                  :max="preferred_date_max",
                  placeholder='（カレンダーから選択）',
                  hide-header=true,
                  :date-format-options="date_picker_format",
                  :date-disabled-fn="dateDisabled",
                  :state="error_msg_list.opening_date.length !== 0 ? false : null"
                )
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.opening_date", :key="i") {{ error_msg }}
                b-form-text
                  p ※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。
                  p ※希望日が弊社休業日の場合、翌営業日のご希望として承ります。
                  p ※希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。
          b-row.other-bg.pt-3
            b-col
              #estimate_no
              b-form-group.align-content(
                label-cols='4',
                label-align='right',
                label-size='sm',
                label='お見積番号',
                :label-class="elective_label_class"
              )
                .form-inline
                  b-form-text.mr-1 No.
                  b-form-textarea.textarea-size(v-model="plan_change_data.estimate_no", rows='3', :state="error_msg_list.estimate_no.length !== 0 ? false : null")
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.estimate_no", :key="i") {{error_msg}}
                b-form-text(text-variant="danger") 既に弊社から見積を取得されている場合、必ずご記入ください。
                b-form-text ※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。
          b-row.other-bg.pt-3
            b-col
              #order_remarks
              b-form-group.align-content(
                label-cols='4',
                label-align='right',
                label-size='sm',
                label='備考',
                :label-class="elective_label_class"
              )
                b-form-textarea.textarea-size(v-model="plan_change_data.order_remarks", rows='4', :state="error_msg_list.order_remarks.length !== 0 ? false : null")
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.order_remarks", :key="i") {{error_msg}}
                b-form-text 弊社への連絡事項などございましたら、こちらにご記入ください。

          #provision_check
          b-row.pt-3
            b-col
              h4.font-weight-bold.mb-3 サービス利用約款など
              b-container
                p.ml-5
                  a(href="https://www.desknets.com/cloud/article.pdf", target="_blank") ＞ desknet'sクラウドサービス利用約款
                p.ml-5
                  a(href="https://www.chatluck.com/terms/tos-cloud.pdf", target="_blank") ＞ ChatLuckクラウドサービス利用約款
                p.ml-5
                  b-link(href="/tos.pdf", target="_blank") ＞ クラウド版サポートサイト利用規約
                b-form-textarea.white-space(v-model="provision_text", :disabled="true", rows="6")
                b-form-group.text-danger(label-cols="12", label-align="left", label-size="sm") お申し込みいただくにあたり、各種サービス約款および上記の各条項にご同意ください。
                b-form-checkbox.ml-5(v-model="plan_change_data.provision_check", :state="error_msg_list.provision_check.length !== 0 ? false : null") 上記の条項に同意します。
                  b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg, i) of error_msg_list.provision_check", :key="i") {{error_msg}}

              b-button.float-right.mr-5.my-3(pill, variant="outline-primary", size="lg", @click="checkChangePlan()", :disabled="api_loading || (plan_change_data.provision_check === false)")
                .float-left.search_message.mr-1.font-weight-bold 次へ
                b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
import Api from '@/repositories/api'
import AppMessages from '@/components/AppMessages'
import Loading from '@/components/Loading'
import SelectDatetime from '@/components/firstOrder/SelectDatetime'

const c204SubdomainCheckRepository = Api.get('c204SubdomainCheck')
const C206ContractInfo = Api.get('c206ContractInfo')
const S210OrderHistoryRepository = Api.get('s210OrderHistory')
const S213ContractDetailsRepository = Api.get('s213ContractDetails')
const S213ContractChangesRepository = Api.get('s213ContractChanges')

export default {
  name: "ApplyPlan",
  components: {
    AppMessages,
    Loading,
    SelectDatetime,
  },
  props: {
    neo_contract: { type: Boolean, required: true },
    neo_contract_status: { type: [String, Boolean], require: true },
    chat_contract: { type: Boolean, required: true },
    chat_contract_status: { type: [String, Boolean], require: true },
    value: { type: Object, required: true },
    plan_change_data: { type: Object, required: true },
  },
  data() {
    return {
      // 必須のラベル
      required_label_class: 'py-05 mb-4 required-label-after',
      // 任意のラベル
      elective_label_class: 'py-05 mb-4 elective-label-after',

      plans: {
        'light': { title: 'ライト', price: 660, services:['neo'], plan: 'light', buttons: '' },
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan: 'standard', buttons: '' },
        'premium': { title: 'プレミアム', price: 1100, services:['neo', 'appsuite', 'chatluck'], plan: 'premium', buttons: '' },
        'chatplus': { title: 'チャットプラス', price: 836, services:['neo', 'chatluck'], plan: 'chatplus', buttons: '' },
        'chatluck': { title: 'ChatLuck', price: 330, services:['chatluck'], plan: 'chatluck', buttons: '' },
      },

      // 申請書
      application_doc: {
        path: '/download/plan_change_application_form.xlsx',
        name: 'プラン変更申請書(2025年12月版).xlsx',
      },

      // 日付ピッカーのフォーマット
      date_picker_format: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      },
      // 変更希望日の最小値
      preferred_date_min: '',
      // 変更希望日の最大値
      preferred_date_max: '',
      // 試使用からの移行作業日時
      migration_datetime: {
        date: '',
        start_time: '',
        end_time: '',
      },

      // 利用約款
      provision_text: "個人情報の取得目的\n" +
          "１．当社は、当Webサイトにおいて、下記に記載する目的でお客さまより個人情報をご提供いただきます。\n" +
          "　①　お客さまからの資料請求、お問合せ、製品購入申込み等々に対する当社からの返信・送付\n" +
          "　②　当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付および製品に関するその他の情報提供\n" +
          "　③　サービスと製品開発のための統計用データとしての利用\n" +
          "　④　カスタマーハラスメント等への対応・事実確認\n" +
          "\n" +
          "\n" +
          "反社会的勢力の排除について\n" +
          "１．お客さまは、現在または将来にわたって、下記のいずれにも該当しないことを表明、確約するものとします。\n" +
          "　①　暴力団\n" +
          "　②　暴力団員\n" +
          "　③　暴力団員でなくなった時から５年を経過しない者\n" +
          "　④　暴力団準構成員\n" +
          "　⑤　暴力団関係企業\n" +
          "　⑥　総会屋等、社会運動標ぼうゴロまたは特殊知能暴力集団\n" +
          "　⑦　その他上記各号に準ずるもの\n" +
          "２．お客さまは、自らまたは第三者を利用し、下記のいずれかに該当する行為を行わないことを表明、確約するものとします。\n" +
          "　①　暴力的な要求行為\n" +
          "　②　法的な責任を超えた不当な要求行為\n" +
          "　③　取引に関して、脅迫的な言動をし、または暴力を用いる行為\n" +
          "　④　風説を流布し、偽計または威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為\n" +
          "　⑤　その他上記各号に準ずる行為\n" +
          "３．お客さまが上記各項のいずれかに反したと認められることが判明した場合、および上記各項の表明、確約が虚偽の申告であることが判明した場合、当社は、催告その他の手続を要しないで、契約の解除その他の当社が必要と判断する対応をとることができます。\n" +
          "４．お客さまは、前項による契約の解除等について、一切異議を申し立てず、また賠償ないし補償を求めないとともに、これより当社に損害が生じた場合は、これを賠償するものします。\n" +
          "\n" +
          "\n" +
          "管轄裁判所\n" +
          "１．本条項に基づく契約は日本法に準拠し、お客さまと当社の間で訴訟の必要が生じた場合には、訴額に応じて、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。",

      // ローディングフラグ
      loading: false,
      // 中断フラグ
      interrupt_flg: false,
      // APIのローディングフラグ
      api_loading: false,
      // プラン変更が画面からできるかどうかのフラグ
      available_plan_change: false,

      // 環境情報
      contract_env_list: [],

      // エラーメッセージリスト
      error_msg_list: {
        top: [],                // 最上部
        changed_user: [],       // 変更後のユーザー数
        neo_domain: [],         // desknet's NEOドメイン名
        migration: [],          // 試使用からの移行フラグ（NEO）
        migration_url: [],      // 試使用環境URL
        chat_domain: [],        // ChatLuckドメイン名
        chat_migration: [],     // 試使用からの移行フラグ（Chat）
        chat_migration_url: [], // ChatLuck試使用環境URL
        opening_date: [],       // 変更希望日
        migration_datetime: [], // 試使用からの移行作業日時
        estimate_no: [],        // お見積番号
        order_remarks: [],      // 備考
        provision_check: [],    // サービス利用約款など
      },
      // エラーメッセージのアンカー位置
      arAnchorList: [
        'top',                // 最上部
        'changed_user',       // 変更後のユーザー数
        'neo_domain',         // desknet's NEOドメイン名
        'migration',          // 試使用からの移行フラグ（NEO）
        'migration_url',      // 試使用環境URL
        'chat_domain',        // ChatLuckドメイン名
        'chat_migration',     // 試使用からの移行フラグ（Chat）
        'chat_migration_url', // ChatLuck試使用環境URL
        'opening_date',       // 変更希望日
        'migration_datetime', // 試使用からの移行作業日時
        'estimate_no',        // お見積番号
        'order_remarks',      // 備考
        'provision_check',    // サービス利用約款など
      ],
      // エラー時のスクロール先
      error_scroll_position: 99,
    }
  },
  computed: {
    /**
     * 変更後のプラン情報を取得
     */
    after_plan_info() {
      return this.getPlanInfo(this.plan_change_data.after_plan)
    },
    /**
     * desknet's NEOドメイン名の入力欄／表示欄を表示するか
     */
    show_neo_domain() {
      // 変更前プランすべてを確認する
      for(let index = 0; index < this.plan_change_data.before_plan.length; index++) {
        // desknet's NEO、ライトプラン、スタンダードプラン、プレミアムプラン、チャットプラスプランのいずれかを契約している場合
        if (['neo', 'light', 'standard', 'premium', 'chatplus'].includes(this.plan_change_data.before_plan[index]) === true) {
          // 表示欄を表示する
          return 'display'
        }
      }

      // 上記以外は入力欄を表示する
      return 'input'
    },
    /**
     * ChatLuckドメイン名の入力欄／表示欄を表示するか
     */
    show_chat_domain() {
      // 変更前プランすべてを確認する
      for(let index = 0; index < this.plan_change_data.before_plan.length; index++) {
        // プレミアムプラン、チャットプラスプラン、ChatLuckのいずれかを契約している場合
        if (['premium', 'chatplus', 'chat'].includes(this.plan_change_data.before_plan[index]) === true) {
          // 表示欄を表示する
          return 'display'
        }
      }
      // 変更後のプランがプレミアムプラン、チャットプラスプランのいずかれの場合
      if (['premium', 'chatplus'].includes(this.plan_change_data.after_plan) === true) {
        // 入力欄を表示する
        return 'input'
      }
      // 上記以外は非表示
      return ''
    },
    /**
     * 表示するdesknet's NEOドメイン名
     */
    display_neo_domain() {
      // 取得した環境情報のdesknet's NEOドメイン名を返す
      return this.contract_env_list.flatMap(item => item.domain_name).find(name => name.endsWith('dn-cloud.com')) || ''
    },
    /**
     * 表示するChatLuckドメイン名
     */
    display_chat_domain() {
      // 取得した環境情報のChatLuckドメイン名を返す
      return this.contract_env_list.flatMap(item => item.domain_name).find(name => name.endsWith('chatluck.net')) || ''
    },
    /**
     * AppSuiteの契約ユーザー数
     */
    contract_appsuite_user() {
      // AppSuiteが存在する場合
      if ('appsuite' in this.plan_change_data.user_list) {
        // AppSuiteの契約中ユーザー数を返す
        return this.plan_change_data.user_list.appsuite
      }

      // 見つからなかった場合は空文字を返す
      return ''
    },
    /**
     * AppSuiteに変更がないかどうか
     */
    no_change_to_appsuite() {
      // 現在のプランに存在する かつ 変更後のプランがチャットプラスの場合
      if (this.plan_change_data.before_plan.includes('appsuite') && this.plan_change_data.after_plan === 'chatplus') {
        // 変更なし
        return true
      }

      // 変更あり
      return false
    },
    /**
     * ChatLuckの契約ユーザー数
     */
    contract_chat_user() {
      // ChatLuckが存在する場合
      if ('chat' in this.plan_change_data.user_list) {
        // ChatLuckの契約中ユーザー数を返す
        return this.plan_change_data.user_list.chat
      }

      // 見つからなかった場合は空文字を返す
      return ''
    },
    /**
     * ChatLuckに変更がないかどうか
     */
    no_change_to_chatluck() {
      // 現在のプランに存在する かつ 変更後のプランがスタンダードの場合
      if (this.plan_change_data.before_plan.includes('chat') && this.plan_change_data.after_plan === 'standard') {
        // 変更なし
        return true
      }

      // 変更あり
      return false
    },
    /**
     * 試使用からの移行作業日時
     */
    showMigrationTime() {
      let sDatetime = '選択してください'

      if (this.migration_datetime.date) {
        // 形式は「2021年11月14日 11:00 - 12:00」
        const arDay = this.migration_datetime.date.split('-')
        const sTime = this.migration_datetime.start_time + ':00 - ' + this.migration_datetime.end_time + ':00'

        sDatetime = arDay[0] + '年' + arDay[1] + '月' + arDay[2] + '日 ' + sTime
      }

      return sDatetime
    },
  },
  created () {
    // ローディング開始
    this.loading = true

    // 販売種別利用制限チェックを行う
    this.validateSalesChannel()

    // セッションストレージから見積枝番を削除
    sessionStorage.removeItem('estimate_branch');
    // 開閉状態を初期化する
    this.plan_change_data.show_change_plan = false
    // 変更希望日の設定
    this.setPreferredDate()
    // 試使用からの移行作業日時を初期化する
    this.migration_datetime.date = this.plan_change_data.migration_date
    this.migration_datetime.start_time = this.plan_change_data.migration_time_from
    this.migration_datetime.end_time = this.plan_change_data.migration_time_to
    // プランに表示するボタンを設定
    this.setCardButton()
  },
  methods : {
    /**
     * プラン情報を取得する
     *
     * @param {string} sPlanName プラン名
     * @return {object} プラン情報
     */
    getPlanInfo(sPlanName) {
      // プランが存在する場合
      if (sPlanName in this.plans) {
        // 指定されたプランを返す
        return this.plans[sPlanName]
      }

      // desknet's NEOの場合
      if (sPlanName === 'neo') {
        // ライトプランを返す
        return this.plans['light']
      }

      // ChatLuckの場合
      if (sPlanName === 'chat') {
        // ChatLuckを返す
        return this.plans['chatluck']
      }

      // プランが存在しない場合は初期データを返す
      return {
        title: '',
        price: '',
        services:[],
        plan: '',
        buttons: []
      }
    },
    /**
     * 「申し込む」ボタンを押した際の処理
     *
     * @param String plan 選択したプラン
     */
    applyPlan(plan) {
      // プランをセット
      localStorage.setItem('plan_name', plan)

      // desknet's NEOの申請の場合
      if (['light', 'standard'].includes(plan)) {
        // desknet's NEO 追加契約画面に遷移する
        this.$router.push({
          name: 'ContractNeoOrder',
          params: {
            contract_no: this.value.contract_no
          },
        })
      }
      // ChatLuckの申請の場合
      if (['chatluck'].includes(plan)) {
        // ChatLuck 追加契約画面に遷移する
        this.$router.push({
          name: 'ContractChatOrder',
          params: {
            contract_no: this.value.contract_no
          },
        })
      }
    },
    /**
     * 契約番号を設定する
     */
    async setContractNo() {
      // 画面パラメータに契約番号が設定されている場合
      if ('contract_no' in this.$route.params) {
        // 契約番号を設定
        this.value.contract_no = this.$route.params.contract_no
        this.plan_change_data.contract_no = this.$route.params.contract_no
      }
      // 上記以外の場合
      else {
        // 取得した環境情報の数が1件の場合
        if (this.contract_env_list.length === 1) {
          // 契約番号を指定
          this.value.contract_no = this.contract_env_list[0].contract_no
          this.plan_change_data.contract_no = this.contract_env_list[0].contract_no
        }
        // 上記以外の場合
        else {
          // セッションストレージにデータを保存
          sessionStorage.setItem('previous', 'ApplyPlan')

          // S11500_ご契約環境選択画面に遷移
          this.$router.push({ name: 'ContractSelect' })

          // 中断フラグをONに設定
          this.interrupt_flg = true
        }
      }
    },
    /**
     * 変更希望日の設定
     */
    setPreferredDate() {
      // 今日の日付の取得
      let currentDate = new Date();

      // 開始日(Dateオブジェクト)
      let startDate = new Date(currentDate);

      // 作業用最小日付
      let formedStartDate = '';

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 本日から空ける必要のある営業日数(N日目が開始日)
      let preparationCount = this.getPreparationDayCount()

      // datepickerの最小値を作成
      // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む
      for (let i = 0; i <= preparationCount; i++) {
        // YYYY-MM-DD の形式にする
        formedStartDate = startDate.getFullYear()
            + '-' + ('00' + (startDate.getMonth() + 1)).slice(-2)
            + '-' + ('00' + startDate.getDate()).slice(-2)

        // 土曜日または日曜日または祝日の場合はスキップ
        if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
          i--
        }

        // 最終日ではない場合は翌日へ
        if (i < preparationCount) {
          startDate.setDate(startDate.getDate() + 1)
        }
      }

      // 最小日付設定
      this.preferred_date_min = formedStartDate

      //--------------------
      // datepickerの最大日付
      //--------------------
      // 翌月末の日付取得
      let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
      this.preferred_date_max = maxDate.getFullYear()
          + '-' + ('00' + (maxDate.getMonth() + 1)).slice(-2)
          + '-' + ('00' + maxDate.getDate()).slice(-2)
    },
    /**
     * datepickerの選択不可日付を設定する
     *
     * @param {string} ymd 対象日付の 'YYYY-MM-DD' 形式の文字列（未使用だが、DatePicker の仕様で渡される
     * @param {Date} date  対象日付の Date オブジェクト
     * @returns {boolean}  true：選択不可、false：選択可能
     */
    dateDisabled(ymd, date) {
      // 曜日を取得する（日曜日 - 土曜日：0 - 6）
      const iWeekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + '-' + ('00' + (date.getMonth() + 1)).slice(-2)
          + '-' + ('00' + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 日曜日と土曜日と祝日の場合、選択不可にする
      return iWeekday === 0 || iWeekday === 6 || holiday.includes(day)
    },
    /**
     * プランに表示するボタンを設定する
     */
    async setCardButton() {
      // 申請中のプラン名
      let processing_order_name = ''
      // 契約内容
      let contract_detail = {}

      // C20601_契約情報取得処理を実行
      await C206ContractInfo.get()
        .then((response) => {
          // 取得した契約情報を保持
          this.contract_env_list = response.data.data
        })
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '画面表示処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          // ローディング終了
          this.loading = false
          // 処理終了
          return
        })

      // 契約番号を設定
      await Promise.all([
        this.setContractNo()
      ])

      // 中断フラグがONの場合
      if (this.interrupt_flg === true) {
        // ローディング終了
        this.loading = false
        // 処理終了
        return
      }

      // 申請中の製品取得
      await S210OrderHistoryRepository.getProcessingNewOrder({contract_no: this.value.contract_no})
        .then((response) => {
          // 申請中のプラン名をセット
          processing_order_name = response.data.data.processing_order
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '注文情報取得処理', 'Support')

          // エラーメッセージをセットする
          this.setErrors(error)

          // 中断フラグをONに設定
          this.interrupt_flg = true
        })

      // 中断フラグがONの場合
      if (this.interrupt_flg === true) {
        // ローディング終了
        this.loading = false
        // 処理終了
        return
      }

      // S21301_契約内容取得処理を実行
      await S213ContractDetailsRepository.view({contract_no: this.value.contract_no})
        .then((response) => {
          // 契約情報をセット
          contract_detail = response.data.data[0]
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '契約明細取得処理', 'Support')

          // エラーメッセージをセットする
          this.setErrors(error)

          // 中断フラグをONに設定
          this.interrupt_flg = true
        })

      // 中断フラグがONの場合
      if (this.interrupt_flg === true) {
        // ローディング終了
        this.loading = false
        // 処理終了
        return
      }

      // 契約明細を基に、表示するボタンを決定する
      await this.setButton(processing_order_name, contract_detail)

      // 「S10303_プラン変更確認」画面から遷移した場合
      if (('fixApply' in this.$route.params) === true) {
        // プランを初期選択する
        this.changePlan(this.plan_change_data.after_plan)
      }

      // ローディング終了
      this.loading = false
    },
    /**
     * 表示するボタンを設定する
     */
    async setButton(processing_order_name, contract) {
      // 変更前プランの初期化
      this.plan_change_data.before_plan = []
      // ユーザー数のリストを初期化
      this.plan_change_data.user_list = {}
      // ユーザー数が同じかどうかのフラグ
      let bSameUser = true

      // ライトプランのボタンを決定
      // ライトプランまたはdesknet's NEO契約中の場合
      if ('light_user' in contract || (contract.neo && 'neo_user' in contract.neo)) {
        // 契約中を表示
        this.plans['light'].buttons = 'contract'
        // 現在のプランとユーザー数を設定
        // desknet's NEOを契約している場合
        if (contract.neo && 'neo_user' in contract.neo) {
          // 変更前プランにdesknet's NEOを設定
          this.plan_change_data.before_plan.push('neo')
          // desknet's NEOのユーザー数を取得
          this.plan_change_data.user_list.neo = contract.neo.neo_user
          // 初期表示の場合
          if (('fixApply' in this.$route.params) === false) {
            // ユーザー数が設定されていて異なる場合
            if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.neo.neo_user)) {
              // ユーザー数が異なるを設定
              bSameUser = false
            }
            this.plan_change_data.plan_user = contract.neo.neo_user
          }
        }
        // ライトプランを契約している場合
        else {
          // 変更前プランにライトを設定
          this.plan_change_data.before_plan.push('light')
          // ライトプランのユーザー数を取得
          this.plan_change_data.user_list.light = contract.light_user
          // 初期表示の場合
          if (('fixApply' in this.$route.params) === false) {
            // ユーザー数が設定されていて異なる場合
            if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.light_user)) {
              // ユーザー数が異なるを設定
              bSameUser = false
            }
            this.plan_change_data.plan_user = contract.light_user
          }
        }
      }
      // ライトプランが申請中の場合
      else if (processing_order_name === 'light') {
        // 申請中を表示
        this.plans['light'].buttons = 'processed'
      }
      // スタンダードプラン・プレミアムプラン・チャットプラスプランを契約している場合
      else if ('standard_user' in contract || 'premium_user' in contract || 'chatplus_user' in contract) {
        // 申請書ボタンを表示
        this.plans['light'].buttons = 'download'
      }
      // 上記以外の場合
      else {
        // 申し込みボタンを表示
        this.plans['light'].buttons = 'apply'
      }

      // スタンダードプランのボタンを決定
      // スタンダードプラン契約中の場合
      if ('standard_user' in contract) {
        // 契約中を表示
        this.plans['standard'].buttons = 'contract'
        // 現在のプランとユーザー数を設定
        this.plan_change_data.before_plan.push('standard')
        // スタンダードプランのユーザー数を取得
        this.plan_change_data.user_list.standard = contract.standard_user
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.standard_user)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
          this.plan_change_data.plan_user = contract.standard_user
        }
      }
      // スタンダードプランが申請中の場合
      else if (processing_order_name === 'standard') {
        // 申請中を表示
        this.plans['standard'].buttons = 'processed'
      }
      // desknet's NEO・ライトプランを契約している場合
      else if ((contract.neo && 'neo_user' in contract.neo) || 'light_user' in contract) {
        // 契約数が1件の場合
        if (this.contract_env_list.length === 1) {
          // プラン変更ボタンを表示
          this.plans['standard'].buttons = 'change'
          // プラン変更が画面からできるようにフラグを設定
          this.available_plan_change = true
        }
        // 契約数が2件以上の場合
        else {
          // 申請書ボタンを表示
          this.plans['standard'].buttons = 'download'
        }
      }
      // desknet's NEO・ライトプラン・プレミアムプラン・チャットプラスプランを契約している場合
      else if ('premium_user' in contract || 'chatplus_user' in contract) {
        // 申請書ボタンを表示
        this.plans['standard'].buttons = 'download'
      }
      // 上記以外の場合
      else {
        // 申し込みボタンを表示
        this.plans['standard'].buttons = 'apply'
      }

      // プレミアムプランのボタンを決定
      // プレミアムプラン契約中の場合
      if ('premium_user' in contract) {
        // 契約中を表示
        this.plans['premium'].buttons = 'contract'
        // 現在のプランとユーザー数を設定
        this.plan_change_data.before_plan.push('premium')
        // プレミアムプランのユーザー数を取得
        this.plan_change_data.user_list.premium = contract.premium_user
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.premium_user)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
          this.plan_change_data.plan_user = contract.premium_user
        }
      }
      // プレミアムプランが申請中の場合
      else if (processing_order_name === 'premium') {
        // 申請中を表示
        this.plans['premium'].buttons = 'processed'
      }
      // 上記以外の場合
      else {
        // 契約数が1件の場合
        if (this.contract_env_list.length === 1) {
          // プラン変更ボタンを表示
          this.plans['premium'].buttons = 'change'
          // プラン変更が画面からできるようにフラグを設定
          this.available_plan_change = true
        }
        // 契約数が2件以上の場合
        else {
          // 申請書ボタンを表示
          this.plans['premium'].buttons = 'download'
        }
      }

      // チャットプラスプランのボタンを決定
      // チャットプラスプラン契約中の場合
      if ('chatplus_user' in contract) {
        // 契約中を表示
        this.plans['chatplus'].buttons = 'contract'
        // 現在のプランとユーザー数を設定
        this.plan_change_data.before_plan.push('chatplus')
        // チャットプラスプランのユーザー数を取得
        this.plan_change_data.user_list.chatplus = contract.chatplus_user
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.chatplus_user)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
          this.plan_change_data.plan_user = contract.chatplus_user
        }
      }
      // チャットプラスプランが申請中の場合
      else if (processing_order_name === 'chatplus') {
        // 申請中を表示
        this.plans['chatplus'].buttons = 'processed'
      }
      // 上記以外の場合
      else {
        // desknet's NEOまたはライトプランまたはChatLuck契約中 かつ スタンダード未契約の場合
        if (((contract.neo && 'neo_user' in contract.neo) || 'light_user' in contract || (contract.chat && 'chat_user' in contract.chat)) && !('standard_user' in contract)) {
          // 契約数が1件の場合
          if (this.contract_env_list.length === 1) {
            // プラン変更ボタンを表示
            this.plans['chatplus'].buttons = 'change'
            // プラン変更が画面からできるようにフラグを設定
            this.available_plan_change = true
          }
          // 契約数が2件以上の場合
          else {
            // 申請書ボタンを表示
            this.plans['chatplus'].buttons = 'download'
          }
        }
        // 上記以外の場合
        else {
          // 申請書ボタンを表示
          this.plans['chatplus'].buttons = 'download'
        }
      }

      // AppSuite（価格改定前）を契約中の場合
      if (contract.neo && 'app_suite_user_old' in contract.neo) {
        // 現在のプランとユーザー数にAppSuiteを追加
        this.plan_change_data.before_plan.push('appsuite')
        this.plan_change_data.user_list.appsuite = contract.neo.app_suite_user_old
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.neo.app_suite_user_old)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
        }
      }
      // AppSuite（価格改定後）を契約中の場合
      if (contract.neo && 'app_suite_user' in contract.neo) {
        // 現在のプランとユーザー数にAppSuiteを追加
        this.plan_change_data.before_plan.push('appsuite')
        this.plan_change_data.user_list.appsuite = contract.neo.app_suite_user
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.neo.app_suite_user)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
        }
      }

      // ChatLuckのボタンを決定
      // ChatLuck契約中の場合
      if (contract.chat && 'chat_user' in contract.chat) {
        // 契約中を表示
        this.plans['chatluck'].buttons = 'contract'
        // 現在のプランとユーザー数を設定
        this.plan_change_data.before_plan.push('chat')
        // ChatLuckのユーザー数を取得
        this.plan_change_data.user_list.chat = contract.chat.chat_user
        // 初期表示の場合
        if (('fixApply' in this.$route.params) === false) {
          // ユーザー数が設定されていて異なる場合
          if (this.plan_change_data.plan_user !== '' && String(this.plan_change_data.plan_user) !== String(contract.chat.chat_user)) {
            // ユーザー数が異なるを設定
            bSameUser = false
          }
          this.plan_change_data.plan_user = contract.chat.chat_user
        }
      }
      // ChatLuckが申請中の場合
      else if (processing_order_name === 'chatluck') {
        // 申請中を表示
        this.plans['chatluck'].buttons = 'processed'
      }
      // プレミアムプラン・チャットプラスプランを契約している場合
      else if ('premium_user' in contract || 'chatplus_user' in contract) {
        // 申請書ボタンを表示
        this.plans['chatluck'].buttons = 'download'
      }
      // 上記以外の場合
      else {
        // 申し込みボタンを表示
        this.plans['chatluck'].buttons = 'apply'
      }

      // ユーザー数が異なる場合
      if (bSameUser === false) {
        // 変更後ユーザー数を設定しない
        this.plan_change_data.plan_user = ''
      }
    },
    /**
     * プラン変更ボタンを押した際の処理
     *
     * @param {string}  sPlanName    選択したプラン名
     * @param {boolean} bTrialUpdate 試使用からの移行フラグを強制的に上書きするか
     */
    async changePlan(sPlanName, bTrialUpdate = false) {
      // プラン変更申し込みを表示する
      this.plan_change_data.show_change_plan = true
      // 変更後のプランを設定
      this.plan_change_data.after_plan = sPlanName
      // 試使用からの移行フラグを上書きする場合
      if (bTrialUpdate === true) {
        // 試使用からの移行フラグを初期化
        this.plan_change_data.migration = false
        // 試使用からの移行フラグ（Chat）を初期化
        this.plan_change_data.chat_migration = false
      }
      // DOMの更新を待つ
      await this.$nextTick()
      // プラン変更申し込みフォームの位置にスクロール
      document.getElementById('change-plan-anchor').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    /**
     * 試使用からの移行作業日時を選択した際の処理
     */
    setDateTime() {
      // モーダルでOKボタンが押下されたら、選択した作業日時を設定値にする
      this.plan_change_data.migration_date = this.migration_datetime.date
      // データ移行作業時刻（から）を保存
      this.plan_change_data.migration_time_from = this.migration_datetime.start_time
      // データ移行作業時刻（まで）を保存
      this.plan_change_data.migration_time_to = this.migration_datetime.end_time
    },
    /**
     * 次へボタンを押した際の処理
     */
    checkChangePlan() {
      // ローディングを開始する
      this.api_loading = true
      // エラーメッセージを初期化する
      this.resetErrorMsg()

      // リクエストパラメータを作成する
      let params = {
        contract_no: this.plan_change_data.contract_no,
        changed_plan: this.plan_change_data.after_plan + '_user',
        changed_user: this.plan_change_data.plan_user,
        neo_domain: this.plan_change_data.neo_sub_domain,
        migration: this.plan_change_data.migration === true ? '1' : '0',
        chat_domain: this.plan_change_data.chat_sub_domain,
        chat_migration: this.plan_change_data.chat_migration === true ? '1' : '0',
        estimate_no: this.plan_change_data.estimate_no,
        order_remarks: this.plan_change_data.order_remarks,
        provision_check: (this.plan_change_data.provision_check === true ? '1' : '0')
      }

      // 試使用からの移行フラグ（NEO）がある場合
      if (this.plan_change_data.migration === true) {
        // リクエストパラメータに以下を追加
        params['migration_url'] = this.plan_change_data.migration_url             // 試使用環境URL
        params['migration_date'] = this.plan_change_data.migration_date           // 試使用移行作業日
        params['migration_time_from'] = this.plan_change_data.migration_time_from // 試使用移行作業時刻（から）
        params['migration_time_to'] = this.plan_change_data.migration_time_to     // 試使用移行作業時刻（まで）
      }
      // 試使用からの移行フラグ（Chat）がある場合
      else if (this.plan_change_data.chat_migration === true) {
        params['chat_migration_url'] = this.plan_change_data.chat_migration_url   // ChatLuck試使用環境URL
        params['migration_date'] = this.plan_change_data.migration_date           // 試使用移行作業日
        params['migration_time_from'] = this.plan_change_data.migration_time_from // 試使用移行作業時刻（から）
        params['migration_time_to'] = this.plan_change_data.migration_time_to     // 試使用移行作業時刻（まで）
      }
      // 上記以外の場合
      else {
        // 変更希望日を設定
        params['opening_date'] = this.plan_change_data.preferred_date
      }

      // S21304_プラン変更確認処理を実行する
      S213ContractChangesRepository.checkPlan(params)
        // 処理に成功した場合
        .then(() => {
          // S10303_プラン変更確認画面に遷移する
          this.$router.push({
            name: 'ConfirmChangePlan'
          })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, 'プラン変更処理')
          // レスポンスデータがある場合
          if (error.response !== null && typeof error.response !== 'undefined') {
            // httpステータスコードが403の場合（権限エラー）
            if (error.response.status === 403) {
              // 画面上部にエラーメッセージを表示する
              this.error_msg_list.top.push(this.forbidden_message);

              // 画面一番上へスクロールをする
              this.pageTopScroll();
            }

            // エラーメッセージがある場合
            if (error.response.data.error_list !== null && typeof error.response.data.error_list !== 'undefined') {
              // エラー要素の取得
              const errList = error.response.data.error_list.error ?? error.response.data.error_list
              // 各要素のエラーメッセージを出力する
              errList.forEach((objErr) => {
                let target = objErr.target
                let errorMsg = objErr.error_msg
                this.responseErrorMessage(target, errorMsg)
              })
              // エラーが出てる場所までスクロール
              this.scrollErrorPosition()
            }
          }
        })
        .finally(() => {
          // ローディング終了
          this.api_loading = false
        })
    },
    /**
     * サブドメインチェック処理を行う
     *
     * @param {string} sType 製品の種類（'0'：neo or '1'：chat）
     */
    domainCheck(sType) {
      // 初期化
      let sSubdomainName = ''

      // サブドメインのエラーメッセージを初期化する
      // desknet's NEOの場合
      if (sType === '0') {
        this.error_msg_list.neo_domain = []
      }
      // ChatLuckの場合
      else {
        this.error_msg_list.chat_domain = []
      }

      // 入力されたドメイン名を設定する
      // desknet's NEOの場合
      if (sType === '0') {
        // desknet's NEOのドメイン名を設定
        sSubdomainName = this.plan_change_data.neo_sub_domain
      }
      // ChatLuckの場合
      else {
        // ChatLuckのドメイン名を設定
        sSubdomainName = this.plan_change_data.chat_sub_domain
      }

      // サブドメインチェック処理を呼び出す
      c204SubdomainCheckRepository.get(encodeURIComponent(sSubdomainName), sType)
        // エラーが発生した場合
        .catch((error) => {
          // エラーメッセージがある場合
          if (error.response.data.error_list !== null && typeof error.response.data.error_list !== 'undefined') {
            // エラー要素の取得
            const errList = error.response.data.error_list.error ?? error.response.data.error_list
            // 各要素のエラーメッセージを出力する
            errList.forEach((objErr) => {
              let target = sType === '0' ? 'neo_domain' : 'chat_domain'
              let errorMsg = objErr.error_msg
              this.responseErrorMessage(target, errorMsg)
            })
          }
        })
    },
    /**
     * エラーメッセージを初期化する
     *
     * @return {void}
     */
    resetErrorMsg() {
      // エラー時のスクロール先をリセット
      this.error_scroll_position = 99;

      // エラーメッセージリスト内のエラーメッセージを全てリセット
      Object.keys(this.error_msg_list).forEach((key) => {
        this.error_msg_list[key] = []
      })
    },
    /**
     * エラーメッセージを設定する
     */
    responseErrorMessage(target, msg) {
      // アンカー位置を初期化
      let anchor_position = 'top'
      // 項目位置がアンカーに存在する場合
      if (this.arAnchorList.includes(target) === true) {
        // アンカー位置を設定
        anchor_position = target
      }
      // 試使用移行作業日時の場合
      if (target === 'migration_date' || target === 'migration_time_from' || target === 'migration_time_to') {
        // アンカー位置を試使用移行作業日時に設定
        anchor_position = 'migration_datetime'
      }
      // アンカー位置を更新
      if (this.compareAnchor(this.error_scroll_position, anchor_position) === true) {
        this.error_scroll_position = anchor_position
      }

      // エラーメッセージを追加する
      this.error_msg_list[anchor_position].push(msg)
    },
    /**
     * アンカー位置を更新
     *
     * @param {string} sCurrentAnchor 現在のアンカー位置
     * @param {string} sTargetAnchor  更新対象のアンカー位置
     * @return {boolean} true：アンカー位置を更新、false：アンカー位置は更新しない
     */
    compareAnchor(sCurrentAnchor, sTargetAnchor) {
      // アンカー位置の優先度で比較
      return this.getAnchorPriority(sCurrentAnchor) > this.getAnchorPriority(sTargetAnchor)
    },
    /**
     * アンカー位置の優先度を取得
     *
     * @param {string} sAnchorPosition アンカー位置
     * @return {int} 優先度
     */
    getAnchorPriority(sAnchorPosition) {
      // 配列を探索する
      for (let iIndex = 0; iIndex < this.arAnchorList.length; iIndex++) {
        // アンカー位置が見つかった場合
        if (this.arAnchorList[iIndex] === sAnchorPosition) {
          // 位置を優先度として返す
          return iIndex;
        }
      }

      // 見つからなかった場合は配列のサイズを優先度として返す
      return this.arAnchorList.length
    },
    /**
     * エラーの箇所までスクロールさせる
     */
    scrollErrorPosition() {
      // アンカーが設定されている場合
      if (this.error_scroll_position !== '' && this.error_scroll_position !== 'top') {
        // アンカーの場所までスクロール
        document.getElementById(this.error_scroll_position).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
      // アンカーが設定されてない
      else {
        // 画面の一番上へ
        this.pageTopScroll();
      }
    },
  }
}
</script>

<style scoped>
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
.height-service-1 {
  height: 80px;
}
.height-service-2 {
  height: 40px;
}
.height-button {
  height: 70px;
}
.input-size {
  width: 260px !important;
}
.plan-bg {
  background-color: #fceaee;
}
.neo-bg {
  background-color: #f2ffff;
}
.chat-bg {
  background-color: #f0ffe0;
}
.other-bg {
  background-color: #f5f5f5;
}
.plan-arrow{
  font-size:72px;
  line-height:1;
  font-weight:700;
}
.textarea-size {
  width: 75% !important;
}
.display-font-size {
  font-size: 16px;
}
</style>
